export default __webpack_public_path__ + "static/media/040_tunnel.hevc.5179583e.mp4";